import React, { useContext, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { doLogin, useAuth, useAuthDispatch, updateUser } from "../context/Auth";
import SystemContext from "../context/System";
import { AUTH_STATUS } from "../constants";

const LoginForm = () => {
  const { status, error } = useAuth();
  const dispatch = useAuthDispatch();

  const { system } = useContext(SystemContext);
  const email_ref = useRef();
  const password_ref = useRef();

  useEffect(() => {
    dispatch({ status: AUTH_STATUS.IDLE, user: null, error: null });
  }, []); // eslint-disable-line

  const _handleSubmit = (e) => {
    e.preventDefault();
    const email = email_ref.current.value;
    const password = password_ref.current.value;
    const user = { email, password, system_id: system.system };
    // add simple validation later
    doLogin(dispatch, user, system.identifier);
  };

  const _handleFocus = () => {
    if (error?.message === 'Incorrect credentials.') {
      updateUser(dispatch, null, true);
    }
    else if (error) {
      updateUser(dispatch, null);
    }
  };

  const inputClassName = `form-control ${system?.identifier}-input ${
    error?.message && "is-invalid"
  }`;

  if (!system) {
    return null;
  }

  return (
    <form onSubmit={_handleSubmit} onFocus={_handleFocus}>
      <div className='form-group pb-3 mb-4'>
        <label>Email</label>
        <input
          type='text'
          name='email'
          className={inputClassName}
          title='email address'
          ref={email_ref}
        />
      </div>
      <div className='form-group'>
        <label>Password</label>
        <input
          type='password'
          name='password'
          className={inputClassName}
          title='password'
          ref={password_ref}
        />
      </div>
      <p
        className={
          error?.message ? "text-center text-danger my-2" : "invisible my-2"
        }
      >
        {error?.message || "."}
      </p>
      <div className='form-group mb-4 text-center'>
        <button
          className={`btn ${system.identifier}-btn`}
          type='submit'
          disabled={status === AUTH_STATUS.PENDING}
        >
          {status === AUTH_STATUS.PENDING ? (
            <span
              className='spinner-border spinner-border-sm'
              role='status'
              aria-hidden='true'
            ></span>
          ) : (
            "Login"
          )}
        </button>
      </div>
      <div className='text-center pb-1 mb-4'>
        <NavLink to='/forget-password' className='fs-7 text-white'>
          Forgot password?
        </NavLink>
      </div>
    </form>
  );
};

export default LoginForm;
